import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="header">
      <div className="header-container">
        <div className="d-flex justify-content-center align-items-center">
          <a href="https://www.jameswellbeloved.de/" target="_blank" rel="noreferrer">
            <picture>
              <img
                src="./assets/images/JWB-logo.png"
                alt="JWB logo"
                className="logo mb-3"
                width={150}
                height={80}
              />
            </picture>
          </a>
        </div>
        <div className="px-xl-3">
          <picture className="d-flex justify-content-center align-items-center">
            <source
              media="(min-width:577px)"
              srcSet="./assets/images/desktop-banner.png"
            />
            <source
              media="(max-width:576px)"
              srcSet="/assets/images/mobile-banner.png"
            />
            <img
              src="./assets/images/desktop-banner.png"
              alt="bannerImage"
              className="banner-img"
              style={{ width: "100%", height: "100%" }}
            />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default Header;
